import React from 'react'
import PropTypes from 'prop-types'
import './Card.scss'

export default function Card({ as: Comp = 'div', children, ...props }) {
  return (
    <Comp {...props} data-card="">
      {children}
    </Comp>
  )
}

export function CardFullBleedHeader({ as: Comp = 'header', children, padding = true, ...props }) {
  return (
    <Comp {...props} data-card-full-bleed-header="" data-padding={padding ? '' : undefined}>
      {children}
    </Comp>
  )
}

export function CardFullBleedImageHeader({ src, alt = 'Card Image', ...props }) {
  return (
    <CardFullBleedHeader padding={false} data-card-full-bleed-image-header="">
      <img {...props} src={src} alt={alt} />
    </CardFullBleedHeader>
  )
}

CardFullBleedImageHeader.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
}
